import React, { useContext } from 'react'
import Input from '../inputs/Input'
import FormGrid from '../layouts/FormGrid'
import Label from '../inputs/Label'
import InputWrap from '../inputs/InputWrap'
import InputGroupTitle from '../inputs/InputGroupTitle'
import PageTitle from '../layouts/PageTitle'
import DateInput from '../inputs/DateInput'
import TextareaInput from '../inputs/TextareaInput'
import CheckboxInput from '../inputs/CheckboxInput'
import useSteps from '../../hooks/useSteps'
import FileInput from '../inputs/FileInput'
import NextStepButton from '../utils/NextStepButton'
import SelectAllCities from '../inputs/SelectAllCities'
import CheckboxAccordion from '../inputs/CheckboxAccordion'
import useInput from '../../hooks/useInput'

export default function AdInformation ({ adRestImageUrl, cities = [] }) {

  const { nextStep } = useSteps()
  const { getValue } = useInput()

  return (
    <>
      <PageTitle step={0}/>

      <FormGrid>
        <Input
          name={'name'}
          label={'Opgavens navn'}
          placeholder={'Fritekst'}/>

        <InputWrap>
          <InputGroupTitle>
            <Label required={true}>Vælg dato til og fra</Label>
            <p>Vælg, hvornår din annonce skal kunne ses på skærmene</p>
          </InputGroupTitle>
          <FormGrid>
            <DateInput
              name={'date_from'}
              required={true}
              placeholder={'Vælg startdato'}
              size={'half'}
              updateWeeks
              updatePrice
              minDate={new Date()}
            />
            <DateInput
              name={'date_to'}
              required={true}
              placeholder={'Vælg slutdato'}
              size={'half'}
              minDate={Date.parse(getValue('date_from')) || new Date()}
            />
          </FormGrid>
        </InputWrap>

        <InputWrap>
          <InputGroupTitle>
            <Label>Hvilke byportaler vil du have annoncen på?</Label>
            <p>For hver valgte byportaler opkræves 250 kr eksl. moms. pr. uge. Ved valg af alle byportaler er prisen
              2.500 kroner pr. uge.</p>
          </InputGroupTitle>
          <FormGrid>
            <InputWrap>
              <div className={'select-all-cities'}>
                <SelectAllCities cities={[...cities]}/>
              </div>
            </InputWrap>
          </FormGrid>
          <CheckboxAccordion height={152} showText={'Vis alle byer'} hideText={'Vis færre byer'}>
            <FormGrid>
              {
                cities.map((city, i) =>
                  <InputWrap key={i} size={'third'}>
                    <CheckboxInput name={'cities'} label={city} value={city} multiple/>
                  </InputWrap>
                )
              }
            </FormGrid>
          </CheckboxAccordion>
        </InputWrap>

        <InputWrap>
          <InputGroupTitle>
            <Label extraText={<>Find de tekniske krav for annoncer <a href="#">her</a></>}>Leverer I selv annoncen?</Label>
          </InputGroupTitle>
          <FormGrid>
            <InputWrap>
              <CheckboxInput
                label={'Ja'}
                value={true}
                name={'delivered_by_customer'}/>
              <div style={{height: '8px'}} />
              <CheckboxInput
                label={'Nej'}
                value={false}
                name={'delivered_by_customer'}/>
            </InputWrap>
          </FormGrid>
        </InputWrap>

        {
          getValue('delivered_by_customer') ?
            <>
              <Input
                name={'headline'}
                label={'Overskrift på annoncen'}
                placeholder={'Fritekst'}
                labelExtraText={'Maks. 500 tegn'}
              />

              <DateInput
                name={'date'}
                label={'Dato'}
                time
                size={'half'}
                placeholder={'Dato og tid'}/>

              <Input
                name={'location'}
                label={'Sted'}
                placeholder={'Fritekst'}
                size={'half'}/>

              <Input
                name={'url'}
                label={'Link til hjemmesiden'}
                placeholder={'https://'}
                type={'url'}/>

              <TextareaInput
                name={'content'}
                label={'Tekst til annoncen og evt. øvrige bemærkninger'}
                placeholder={'Fritekst'}/>
              </>
            : null
        }

        <FileInput
            label={'Upload billede'}
            name={'image'}
            required={true}
            restUrl={adRestImageUrl}
        />

        <InputWrap>
          <div className={'ad-next-step'}>
            <NextStepButton label={'Videre'} style={'secondary'}/>
          </div>
        </InputWrap>
      </FormGrid>
    </>
  )
}
